// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetClaim,
    updateClaimQuestionChoice,
    updateContactDate,
    updateEMail,
    updateFirstName,
    updateFormValidation,
    updateLastName,
    updateMethodOfContact,
    updateRelationship,
    updateStickyHeaderVisibility,
    updateWorkOrderOne,
    updateWorkOrderTwo
} from './claim-details';
import {
    resetConfirmationModal,
    updateConfirmationModal
} from './confirmation-modal';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createClaim} from './validate-claim';
import {onEditClaim} from '../../../shared/action-creators/edit-claim';
import {readClaim} from './get-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readGoodsInstallationVatOptions} from '../../../shared/action-creators/get-goods-installation-vat-options';
import {readMccQuestions} from './get-mcc-questions';
import {readMethodOfContactOptions} from './get-method-of-contact-options';
import {readQuestionsRequiredOptions} from './get-questions-required-options';
import {readRelationshipOptions} from './get-relationship-options';
import {resetCkcCustomerFailure} from '../../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../../shared/action-creators/latest-per-unit-measurements';
import {resetMccQuestions} from './reset-mcc-questions';
import {resetProductDetails} from './reset-product-details';
import {toggleWarrentyStatusModal} from '../../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updatePin} from './pin';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../../product/details/action-creators/warranties';

export default {
    addFile,
    additionalRepair,
    copyAttachments,
    copyClaim,
    createClaim,
    deleteFile,
    onCreateClaim,
    onEditClaim,
    readClaim,
    readClaimProduct,
    readClaimTypes,
    readGoodsInstallationVatOptions,
    readMccQuestions,
    readMethodOfContactOptions,
    readQuestionsRequiredOptions,
    readRelationshipOptions,
    resetCkcCustomerFailure,
    resetClaim,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetMccQuestions,
    resetProductDetails,
    toggleWarrentyStatusModal,
    updateClaimModalMode,
    updateClaimQuestionChoice,
    updateConfirmationModal,
    updateContactDate,
    updateCreateClaimModalVisibility,
    updateEMail,
    updateFirstName,
    updateFormValidation,
    updateGoodsInstallationVat,
    updateIsEditable,
    updateLastName,
    updateMethodOfContact,
    updatePin,
    updateRelationship,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateWarranties,
    updateWorkOrderOne,
    updateWorkOrderTwo
};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/index.js